import {inject, Injectable} from '@angular/core';
import { Config } from '../../config/config.service';
import { PostMessageService } from '../postmessage/postmessage.service';
import {interval} from "rxjs";
// import {interval} from "rxjs";

@Injectable()

export class ResizeService {
  private _config = inject(Config);
  private _postMessageService = inject(PostMessageService);
  public allowResizeEvents = this._config.CONFIG.allowResizeEvents;

  public height: number | undefined;

  // listen() {
  //   if (this.allowResizeEvents) {
  //     const merchant_element = document.getElementById('merchant');
  //     if (!merchant_element) return;
  //
  //     this.ngZone.runOutsideAngular(() => {
  //       const resizeObserver = new ResizeObserver(entries => {
  //         for (const entry of entries) {
  //           const newHeight = entry.contentRect.height;
  //           if (this.height !== newHeight) {
  //             this.onHeightChanged(newHeight);
  //           }
  //         }
  //       });
  //
  //       resizeObserver.observe(merchant_element);
  //     });
  //   }
  // }

  // listen() {
  //   if (this.allowResizeEvents) {
  //     this.ngZone.runOutsideAngular(() => {
  //       interval(500).subscribe(() => {
  //         const merchant_element = document.getElementById('merchant');
  //         if (merchant_element) {
  //           if (this.height !== merchant_element.clientHeight) {
  //             this.onHeightChanged(merchant_element.clientHeight);
  //           }
  //         }
  //       });
  //     });
  //   }
  // }

  listen() {
    if (this.allowResizeEvents) {
      interval(500).pipe().subscribe(() => {
        const merchant_element = document.getElementById('merchant');
        if (merchant_element) {
          if (this.height !== merchant_element.clientHeight) {
            this.onHeightChanged(merchant_element.clientHeight);
          }
        }
      })
    }
  }


  onHeightChanged(height: number) {
    this.height = height;
    this._postMessageService.resize({
      height: height
    });
  }
}
